import React, { useEffect, useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import IndicatorsAccordion from './IndicatorsAccordion';
import IndicatorsListForTargetMobile from './IndicatorsListForTargetMobile';
import TargetAssessment from './TargetAssessment';
import SDGSpinner from './SDGSpinner';
import { IndicatorsContext } from '../State/IndicatorsContext';
import { GoalsContext } from '../State/GoalsContext';
import '../index.css';
import '../utils/sharedStyles.css';

const IndicatorDetails = ({ selectedTarget, selectedTargetId }) => {
  const { indicators, loading, fetchAllIndicatorsByTarget } = useContext(IndicatorsContext);
  const { goalType } = useContext(GoalsContext);
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  // Filter indicators by target_id as a safeguard
  // Convert both to numbers for comparison to handle string/number mismatches
  const filteredIndicators = indicators.filter(indicator => {
    if (!selectedTargetId) return true;
    const indicatorTargetId = indicator.target_id ? parseInt(String(indicator.target_id)) : null;
    const selectedId = parseInt(String(selectedTargetId));
    return indicatorTargetId === selectedId;
  });

  useEffect(() => {
    if (selectedTargetId !== null && selectedTargetId !== undefined) {
      fetchAllIndicatorsByTarget(selectedTargetId, goalType);
    }
  }, [selectedTargetId, goalType, fetchAllIndicatorsByTarget]);

  if (loading && indicators.length === 0) {
    return <SDGSpinner size="md" text="Loading indicators..." />;
  }

  if (selectedTargetId && !loading && filteredIndicators.length === 0 && indicators.length === 0) {
    return (
      <div>
        <p className='help-text'>
          <i className="bi bi-exclamation-triangle icon-help"></i>
          No indicators data found for this target.
        </p>
      </div>
    );
  }

  return (
    <div className={`indicator-details-container${isMobile ? ' indicator-details-container--mobile' : ''}`}>
      {selectedTarget ? (
        <div className={isMobile ? 'indicator-details-mobile-body' : 'card-container'}>
          {!isMobile && (
            <>
              <h2 className="title-h2">
                <strong>TARGET {selectedTarget.acf.index} –</strong> {selectedTarget.title || selectedTarget.title_render}
              </h2>
              <TargetAssessment target={selectedTarget} />
            </>
          )}
          {filteredIndicators.length > 0 ? (
            isMobile ? (
              <IndicatorsListForTargetMobile indicators={filteredIndicators} />
            ) : (
              <IndicatorsAccordion indicators={filteredIndicators} />
            )
          ) : loading ? (
            <SDGSpinner size="sm" text="Loading indicators for this target..." />
          ) : (
            <div>
              <p className='help-text'>
                <i className="bi bi-exclamation-triangle icon-help"></i>
                No indicators available for this target.
              </p>
            </div>
          )}
        </div>
      ) : selectedTargetId ? (
        // Target ID is set but target object not loaded yet
        <SDGSpinner size="sm" text="Loading target information..." />
      ) : (
        <div>
          <p className='help-text'>
            <i className="bi bi-bar-chart-line-fill icon-help"></i>
            Please select a target to browse the indicators
          </p>
        </div>
      )}
    </div>
  );
};

export default IndicatorDetails;
